import { TimechiefClient } from "../timechiefclient";

class SetupService {
    getDevice(uuid) {
        return TimechiefClient.default.getDeviceById(uuid);
    }

    updateDevice(device) {
        return TimechiefClient.default.updateDevice(device);
    }

    getTheme(uuid) {
        return TimechiefClient.default.getThemeById(uuid);
    }

    updateTheme(theme) {
        return TimechiefClient.default.updateTheme(theme);
    }

    deleteBucketFile(uuid) {
        return TimechiefClient.default.deleteBucketFileById(uuid);
    }

    listThemePresetImages() {
        return this.listBucketFilesByTag("theme_preset_thumb");
    }

    listBucketFilesByTag(tag) {
        const fetchRecursive = function (offset, limit, files) {
            return TimechiefClient.default.listBucketFiles(offset, limit, tag).then(page => {
                const allFiles = files.concat(page);
                if (page.length === limit) {
                    return fetchRecursive(offset + limit, limit, allFiles);
                } else {
                    return allFiles;
                }
            });
        };
        return fetchRecursive(0, 50, []);
    }

    listBackgroundImages() {
        return this.listBucketFilesByTag("builtin_theme_image_thumb")
            .then(builtinImages => {
                return this.listBucketFilesByTag("user_background_image_thumb")
                    .then(thumbImages => {
                        return this.listBucketFilesByTag("user_background_image").then(wholeImages => {
                            const readyUserImages = wholeImages.filter(img => img.status === "ready-to-serve");
                            const readyUserImagesByUUID = new Set(readyUserImages.map(img => img.uuid));
                            const readyThumbs = thumbImages.filter(thumb => {
                                const linkedUUID = thumb.metadata.link;
                                return linkedUUID && readyUserImagesByUUID.has(linkedUUID);
                            });
                            return builtinImages.concat(readyThumbs);
                        })
                    });
            });
    }

    applyThemePreset(themeUUID, presetName) {
        const body = {
            theme_uuid: themeUUID,
            preset_name: presetName
        };
        return TimechiefClient.default.applyPresetTheme(body);
    }

    applyThemePhysicalLayoutDefaults(themeUUID, width, height) {
        const body = {
            theme_uuid: themeUUID,
            width: width,
            height: height
        }
        return TimechiefClient.default.applyThemePhysicalLayoutDefaults(body);
    }

    markBucketFileUploadComplete(uuid) {
        return TimechiefClient.default.markBucketFileUploadComplete(uuid);
    }

    createBucketFile(tag, contentType) {
        const bucketFile = {
            uuid: crypto.randomUUID(),
            tag: tag,
            mimetype: contentType,
            status: "upload-pending"
        }
        return TimechiefClient.default.createBucketFile(bucketFile);
    }

    getBucketFileUploadURL(uuid) {
        const fetchUploadURL = (uuid, retries = 30, delay = 1000) => {
            return TimechiefClient.default.getBucketFileUpload(uuid).then(val => {
                if (val.upload_url) {
                    return val.upload_url;
                } else if (retries > 0) {
                    return new Promise(resolve => setTimeout(resolve, delay))
                        .then(() => fetchUploadURL(uuid, retries - 1, delay));
                } else {
                    throw new Error('Upload URL not found after multiple attempts');
                }
            });
        };

        return fetchUploadURL(uuid);
    }

    getBucketFileDownloadURL(uuid) {
        const fetchDownloadURL = (uuid, retries = 30, delay = 1000) => {
            return TimechiefClient.default.getBucketFileDownload(uuid).then(val => {
                if (val.download_url) {
                    return val.download_url;
                } else if (retries > 0) {
                    return new Promise(resolve => setTimeout(resolve, delay))
                        .then(() => fetchDownloadURL(uuid, retries - 1, delay));
                } else {
                    throw new Error('Download URL not found after multiple attempts');
                }
            });
        };

        return fetchDownloadURL(uuid);
    }
}

export const Service = new SetupService();